import React from 'react';
import { toast } from 'react-toastify';

import { UiComponent } from 'components';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';
import useModal from 'hooks/useModal';
import { PushQuery } from 'queries';
import { IEvent } from 'types';
import useEventDelete from '../Detail/useEventDelete';
import { useEventStatus } from '../Detail/useEventStatus';
import * as S from './style';

type EventStatus = IEvent['eventStatus'];

const NEXT_STATUS: Partial<
  Record<EventStatus, { status: EventStatus; label: string }>
> = {
  REVIEW: { status: 'RECRUITING', label: '행사 승인' },
  RECRUITING: { status: 'RECRUITMENT_CLOSED', label: '모집 완료' },
  RECRUITMENT_CLOSED: { status: 'COMPLETED', label: '진행 완료' },
};

interface Props {
  event: IEvent;
}

function Actions({ event }: Props) {
  const { handleConfirm } = useModal();
  const { handleEventStatus } = useEventStatus({ event });
  const { handleConfirmDelete } = useEventDelete(event);
  const { mutate: postFeedbackNotification } =
    PushQuery.usePostFeedbackNotification();

  if (event.eventStatus === 'CANCELLED') return null;

  const next = NEXT_STATUS[event.eventStatus];
  const canCancel = event.eventStatus !== 'COMPLETED';
  const canNotifyFeedback = event.eventStatus === 'COMPLETED';

  const confirmFeedbackNotification = () =>
    handleConfirm({
      confirmContent: '참석자에게 피드백 알림을 전송하시겠습니까?',
      yesTitle: '전송',
      noTitle: '닫기',
      confirmNext: () =>
        postFeedbackNotification(event.id, {
          onSuccess: () => toast.success('피드백 알림이 전송되었습니다.'),
          onError: () => toast.error(DEFAULT_ERROR_MESSAGE),
        }),
    });

  const confirmStatus = (status: EventStatus, label: string) =>
    handleConfirm({
      confirmContent: `${label} 처리하시겠습니까?`,
      yesTitle: label,
      noTitle: '닫기',
      confirmNext: () => handleEventStatus(status),
    });

  return (
    <div css={S.actions}>
      {next && (
        <UiComponent.Button
          variant="contained"
          color="primary"
          css={S.actionButton}
          onClick={() => confirmStatus(next.status, next.label)}
        >
          {next.label}
        </UiComponent.Button>
      )}
      {canNotifyFeedback && (
        <UiComponent.Button
          variant="contained"
          color="primary"
          css={S.actionButton}
          onClick={confirmFeedbackNotification}
        >
          피드백 알림 전송
        </UiComponent.Button>
      )}
      <div css={S.subActions}>
        {canCancel && (
          <UiComponent.Button
            variant="border"
            color="grey"
            css={S.actionButton}
            onClick={() => confirmStatus('CANCELLED', '행사 취소')}
          >
            행사 취소
          </UiComponent.Button>
        )}
        <UiComponent.Button
          variant="border"
          color="grey"
          css={S.actionButton}
          onClick={handleConfirmDelete}
        >
          행사 삭제
        </UiComponent.Button>
      </div>
    </div>
  );
}

export default Actions;
